import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
interface CodeBlockProps {
  code: Record<string, string>;
  defaultLanguage?: string;
}
const languages = [{
  id: 'curl',
  label: 'cURL'
}, {
  id: 'node',
  label: 'Node.js'
}, {
  id: 'python',
  label: 'Python'
}, {
  id: 'go',
  label: 'Go'
}, {
  id: 'java',
  label: 'Java'
}, {
  id: 'php',
  label: 'PHP'
}, {
  id: 'ruby',
  label: 'Ruby'
}, {
  id: 'dotnet',
  label: '.NET'
}];
export function CodeBlock({
  code,
  defaultLanguage = 'curl'
}: CodeBlockProps) {
  const [activeLanguage, setActiveLanguage] = useState(defaultLanguage);
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(code[activeLanguage] || '');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const availableLanguages = languages.filter(lang => code[lang.id]);
  return <div className="my-6 bg-slate-50 rounded-xl border border-slate-200 overflow-hidden" data-id="element-23">
      {/* Language Tabs */}
      <div className="flex items-center gap-1 px-4 pt-3 overflow-x-auto border-b border-slate-200 bg-white" data-id="element-24">
        {availableLanguages.map(lang => <button key={lang.id} onClick={() => setActiveLanguage(lang.id)} className={`px-4 py-2 text-sm font-medium rounded-t transition-colors whitespace-nowrap ${activeLanguage === lang.id ? 'bg-slate-900 text-white' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'}`} data-id="element-25">
            {lang.label}
          </button>)}
      </div>

      {/* Code Content */}
      <div className="relative bg-slate-900 p-6" data-id="element-26">
        <pre className="text-sm text-slate-100 font-mono overflow-x-auto" data-id="element-27">
          <code data-id="element-28">{code[activeLanguage]}</code>
        </pre>

        {/* Copy Button */}
        <button onClick={handleCopy} className="absolute top-4 right-4 p-2 rounded bg-slate-800 hover:bg-slate-700 text-slate-300 hover:text-white transition-colors" data-id="element-29">
          {copied ? <Check className="w-4 h-4" data-id="element-30" /> : <Copy className="w-4 h-4" data-id="element-31" />}
        </button>
      </div>
    </div>;
}